import instance from "../services/axios";
import { Item } from "../types/Item";

export const getArticleMetadataByErpNumber = async (
  articleNumber: string
): Promise<Item | null> => {
  try {
    const { data: items } = await instance.get(
      `/api/MetaBackend/Item/GetItemByNumber?number=${articleNumber}`
    );

    if (Array.isArray(items)) {
      return items.find((item) => item.active === true) || null;
    }

    if (items?.active) {
      return items;
    }

    return null;
  } catch (error) {
    console.error("Failed to fetch item:", error);
    return null;
  }
};
